import { render, staticRenderFns } from "./ProfileClient.vue?vue&type=template&id=01a797d4&scoped=true"
import script from "./ProfileClient.vue?vue&type=script&lang=js"
export * from "./ProfileClient.vue?vue&type=script&lang=js"
import style0 from "./ProfileClient.vue?vue&type=style&index=0&id=01a797d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a797d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VProgressCircular,VSwitch})
